import type { ProjectVersion } from './types.js';

export function matchProjectVersion(
  versions: ProjectVersion[],
  version: number | string,
): ProjectVersion | null {
  if (typeof version === 'number') {
    return versions.find((entry) => entry.versionNo === version) ?? null;
  }

  const trimmed = version.trim();
  if (!trimmed) return null;

  const numeric = Number(trimmed);
  if (Number.isInteger(numeric) && String(numeric) === trimmed) {
    return versions.find((entry) => entry.versionNo === numeric) ?? null;
  }

  const versionPrefix = trimmed.match(/^v(\d+)$/i);
  if (versionPrefix) {
    const versionNo = Number(versionPrefix[1]);
    return versions.find((entry) => entry.versionNo === versionNo) ?? null;
  }

  const needle = trimmed.toLowerCase();
  return versions.find(
    (entry) => entry.versionName?.trim().toLowerCase() === needle,
  ) ?? null;
}
